<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
    <path fill="currentColor" d="M0.75 6C0.75 5.58579 1.08579 5.25 1.5 5.25H12C12.4142 5.25 12.75 5.58579 12.75 6C12.75 6.41421 12.4142 6.75 12 6.75H1.5C1.08579 6.75 0.75 6.41421 0.75 6Z" />
    <path fill="currentColor" d="M6.75 0C7.16421 1.81058e-08 7.5 0.335786 7.5 0.75L7.5 11.25C7.5 11.6642 7.16421 12 6.75 12C6.33579 12 6 11.6642 6 11.25L6 0.75C6 0.335786 6.33579 -1.81058e-08 6.75 0Z" />
  </svg>
</template>